import React from 'react'
import PropTypes from 'prop-types'
import { ModalWrapper } from './FileViewPopupStyled'
import utils from '../../utils'
import FilePreview from '../PDFViewer/FilePreview'

const FileViewPopupV2 = props => {
  const { isVisibleFileViewPopup, handleCloseFileViewPopup, file } = props

  return (
    <ModalWrapper
      title={`Tài liệu:  ${file.file_name}`}
      visible={isVisibleFileViewPopup}
      onCancel={handleCloseFileViewPopup}
      style={{ top: 20 }}
      width={utils.isIOSDevice() ? 800 : 1100}
      footer={null}>
      <FilePreview
        fileId={file.file_id}
        fileType={utils.getExtensionFile(file.file_name)}
        fileName={file.file_name}
      />
    </ModalWrapper>
  )
}

FileViewPopupV2.propTypes = {
  isVisibleFileViewPopup: PropTypes.bool.isRequired,
  handleCloseFileViewPopup: PropTypes.func.isRequired,
  file: PropTypes.object.isRequired,
}

export default FileViewPopupV2
